import React from 'react';
import PropTypes from 'prop-types';

import './LangSwitch.css';

const LangSwitch = ({ handleChangeLocale }) => (
  <div className="md-cell--right langSwitch">
    <ul>
      <li><button onClick={() => handleChangeLocale('fr')}>fr</button></li>
      <li><button onClick={() => handleChangeLocale('nl')}>nl</button></li>
      <li><button onClick={() => handleChangeLocale('en')}>en</button></li>
      <li><button onClick={() => handleChangeLocale('de')}>de</button></li>
    </ul>
  </div>
);

LangSwitch.propTypes = {
  handleChangeLocale: PropTypes.func.isRequired,
};

export default LangSwitch;



// WEBPACK FOOTER //
// ./src/components/Login/LangSwitch.js